module.exports = __webpack_public_path__ + "static/media/importsLink.391753f9.svg";